export const albums_data = {
   "travel-gran-canaria-el-confital": {
      "name": "travel-gran-canaria > el-confital",
      "photos": [
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_151741274.jpg",
            "slug": "img-20250913-151741274-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151741274-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-151741274-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151741274-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151741274-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-151741274-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151741274-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_151748417.jpg",
            "slug": "img-20250913-151748417-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151748417-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-151748417-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151748417-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151748417-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-151748417-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151748417-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_151954124_HDR.jpg",
            "slug": "img-20250913-151954124-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151954124-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-151954124-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-151954124-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151954124-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-151954124-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151954124-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_152738500.jpg",
            "slug": "img-20250913-152738500-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-152738500-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-152738500-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-152738500-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-152738500-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-152738500-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-152738500-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_152833667.jpg",
            "slug": "img-20250913-152833667-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-152833667-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-152833667-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-152833667-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-152833667-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-152833667-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-152833667-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_153226066.jpg",
            "slug": "img-20250913-153226066-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153226066-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-153226066-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153226066-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153226066-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-153226066-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153226066-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_153357433.jpg",
            "slug": "img-20250913-153357433-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153357433-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-153357433-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153357433-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153357433-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-153357433-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153357433-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250913_153410543.jpg",
            "slug": "img-20250913-153410543-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-153410543-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x1365_img-20250913-153410543-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-153410543-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-153410543-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x1066_img-20250913-153410543-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-153410543-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_153545443.jpg",
            "slug": "img-20250913-153545443-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153545443-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-153545443-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-153545443-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153545443-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-153545443-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-153545443-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_154712846.jpg",
            "slug": "img-20250913-154712846-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-154712846-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-154712846-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-154712846-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-154712846-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-154712846-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-154712846-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_160633675.jpg",
            "slug": "img-20250913-160633675-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-160633675-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-160633675-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-160633675-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-160633675-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-160633675-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-160633675-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_161345024.jpg",
            "slug": "img-20250913-161345024-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161345024-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-161345024-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161345024-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161345024-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-161345024-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161345024-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_161533764.jpg",
            "slug": "img-20250913-161533764-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161533764-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-161533764-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161533764-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161533764-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-161533764-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161533764-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250913_161714438.jpg",
            "slug": "img-20250913-161714438-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-161714438-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x1365_img-20250913-161714438-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-161714438-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-161714438-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x1066_img-20250913-161714438-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-161714438-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_161724124.jpg",
            "slug": "img-20250913-161724124-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161724124-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-161724124-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-161724124-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161724124-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-161724124-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-161724124-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250913_161843967.jpg",
            "slug": "img-20250913-161843967-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-161843967-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x1365_img-20250913-161843967-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-161843967-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-161843967-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x1066_img-20250913-161843967-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-161843967-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_162519974_HDR.jpg",
            "slug": "img-20250913-162519974-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162519974-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-162519974-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162519974-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162519974-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-162519974-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162519974-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250913_162552660_HDR.jpg",
            "slug": "img-20250913-162552660-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-162552660-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x1365_img-20250913-162552660-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x2133_img-20250913-162552660-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-162552660-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x1066_img-20250913-162552660-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x666_img-20250913-162552660-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_162606151_HDR.jpg",
            "slug": "img-20250913-162606151-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162606151-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-162606151-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162606151-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162606151-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-162606151-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162606151-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_162639245.jpg",
            "slug": "img-20250913-162639245-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162639245-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-162639245-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-162639245-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162639245-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-162639245-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-162639245-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_163102734_HDR.jpg",
            "slug": "img-20250913-163102734-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-163102734-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-163102734-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-163102734-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-163102734-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-163102734-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-163102734-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_163109817_HDR.jpg",
            "slug": "img-20250913-163109817-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-163109817-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-163109817-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-163109817-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-163109817-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-163109817-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-163109817-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_165520398.jpg",
            "slug": "img-20250913-165520398-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-165520398-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-165520398-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-165520398-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-165520398-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-165520398-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-165520398-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250913_170009669.jpg",
            "slug": "img-20250913-170009669-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-170009669-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1024x768_img-20250913-170009669-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/1600x1200_img-20250913-170009669-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-170009669-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/800x600_img-20250913-170009669-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-170009669-jpg.jpg",
            "width": 4096
         }
      ],
      "slug": "travel-gran-canaria-el-confital",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-el-confital/500x375_img-20250913-151741274-jpg.jpg"
   },
   "travel-gran-canaria-hike": {
      "name": "travel-gran-canaria > hike",
      "photos": [
         {
            "faces": [],
            "height": 1134,
            "name": "IMG-20250906-WA0042.jpg",
            "slug": "img-20250906-wa0042-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x900_img-20250906-wa0042-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x576_img-20250906-wa0042-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x900_img-20250906-wa0042-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x281_img-20250906-wa0042-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x450_img-20250906-wa0042-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x281_img-20250906-wa0042-jpg.jpg",
            "width": 2016
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250906_132034572_HDR.jpg",
            "slug": "img-20250906-132034572-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-132034572-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x768_img-20250906-132034572-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-132034572-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-132034572-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x600_img-20250906-132034572-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-132034572-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250906_140104396.jpg",
            "slug": "img-20250906-140104396-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-140104396-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x1365_img-20250906-140104396-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-140104396-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-140104396-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x1066_img-20250906-140104396-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-140104396-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250906_152848926.jpg",
            "slug": "img-20250906-152848926-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-152848926-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x1365_img-20250906-152848926-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-152848926-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-152848926-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x1066_img-20250906-152848926-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-152848926-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250906_152917879.jpg",
            "slug": "img-20250906-152917879-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-152917879-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x1365_img-20250906-152917879-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x2133_img-20250906-152917879-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-152917879-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x1066_img-20250906-152917879-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x666_img-20250906-152917879-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250906_152922906.jpg",
            "slug": "img-20250906-152922906-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-152922906-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x768_img-20250906-152922906-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-152922906-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-152922906-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x600_img-20250906-152922906-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-152922906-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250906_154548162.jpg",
            "slug": "img-20250906-154548162-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-154548162-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x768_img-20250906-154548162-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1600x1200_img-20250906-154548162-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-154548162-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x600_img-20250906-154548162-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x375_img-20250906-154548162-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 1382,
            "name": "gran-canaria-hike.jpeg",
            "slug": "gran-canaria-hike-jpeg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1404x1382_gran-canaria-hike-jpeg.jpeg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1024x1007_gran-canaria-hike-jpeg.jpeg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/1404x1382_gran-canaria-hike-jpeg.jpeg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x492_gran-canaria-hike-jpeg.jpeg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/800x787_gran-canaria-hike-jpeg.jpeg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x492_gran-canaria-hike-jpeg.jpeg",
            "width": 1404
         }
      ],
      "slug": "travel-gran-canaria-hike",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-hike/500x281_img-20250906-wa0042-jpg.jpg"
   },
   "travel-gran-canaria-las-canteras": {
      "name": "travel-gran-canaria > las-canteras",
      "photos": [
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250905_192452537_HDR.jpg",
            "slug": "img-20250905-192452537-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250905-192452537-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x768_img-20250905-192452537-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250905-192452537-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250905-192452537-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x600_img-20250905-192452537-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250905-192452537-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 2978,
            "name": "IMG_20250912_195656925.jpg",
            "slug": "img-20250912-195656925-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195656925-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x768_img-20250912-195656925-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195656925-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195656925-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x600_img-20250912-195656925-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195656925-jpg.jpg",
            "width": 3969
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250912_195708167.jpg",
            "slug": "img-20250912-195708167-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195708167-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x768_img-20250912-195708167-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195708167-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195708167-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x600_img-20250912-195708167-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195708167-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250912_195915372.jpg",
            "slug": "img-20250912-195915372-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195915372-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x768_img-20250912-195915372-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-195915372-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195915372-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x600_img-20250912-195915372-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-195915372-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3016,
            "name": "IMG_20250912_200156121_HDR.jpg",
            "slug": "img-20250912-200156121-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1199_img-20250912-200156121-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x767_img-20250912-200156121-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1199_img-20250912-200156121-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/499x374_img-20250912-200156121-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x599_img-20250912-200156121-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/499x374_img-20250912-200156121-hdr-jpg.jpg",
            "width": 4022
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250912_201523308.jpg",
            "slug": "img-20250912-201523308-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-201523308-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1024x768_img-20250912-201523308-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/1600x1200_img-20250912-201523308-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-201523308-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/800x600_img-20250912-201523308-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250912-201523308-jpg.jpg",
            "width": 4096
         }
      ],
      "slug": "travel-gran-canaria-las-canteras",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-canteras/500x375_img-20250905-192452537-hdr-jpg.jpg"
   },
   "travel-gran-canaria-las-palmas-old-city": {
      "name": "travel-gran-canaria > las-palmas-old-city",
      "photos": [
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250914_110938497_HDR.jpg",
            "slug": "img-20250914-110938497-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-110938497-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x768_img-20250914-110938497-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-110938497-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-110938497-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x600_img-20250914-110938497-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-110938497-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_111348963_HDR.jpg",
            "slug": "img-20250914-111348963-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111348963-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-111348963-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111348963-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111348963-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-111348963-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111348963-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_111511107_HDR.jpg",
            "slug": "img-20250914-111511107-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111511107-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-111511107-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111511107-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111511107-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-111511107-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111511107-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_111548279_HDR.jpg",
            "slug": "img-20250914-111548279-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111548279-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-111548279-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-111548279-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111548279-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-111548279-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-111548279-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250914_111638128.jpg",
            "slug": "img-20250914-111638128-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-111638128-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x768_img-20250914-111638128-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-111638128-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-111638128-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x600_img-20250914-111638128-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-111638128-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_113043980.jpg",
            "slug": "img-20250914-113043980-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-113043980-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-113043980-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-113043980-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-113043980-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-113043980-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-113043980-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250914_114907543.jpg",
            "slug": "img-20250914-114907543-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-114907543-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x768_img-20250914-114907543-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x1200_img-20250914-114907543-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-114907543-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x600_img-20250914-114907543-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-114907543-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_115004968_HDR.jpg",
            "slug": "img-20250914-115004968-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-115004968-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-115004968-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-115004968-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-115004968-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-115004968-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-115004968-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3619,
            "name": "IMG_20250914_134430833_HDR.jpg",
            "slug": "img-20250914-134430833-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-134430833-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-134430833-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-134430833-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-134430833-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-134430833-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-134430833-hdr-jpg.jpg",
            "width": 2714
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250914_134559894.jpg",
            "slug": "img-20250914-134559894-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-134559894-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1024x1365_img-20250914-134559894-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/1600x2133_img-20250914-134559894-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-134559894-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/800x1066_img-20250914-134559894-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x666_img-20250914-134559894-jpg.jpg",
            "width": 3072
         }
      ],
      "slug": "travel-gran-canaria-las-palmas-old-city",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-las-palmas-old-city/500x375_img-20250914-110938497-hdr-jpg.jpg"
   },
   "travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas": {
      "name": "travel-gran-canaria > puerto-de-mogan-dunas-de-maspalomas",
      "photos": [
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_110357002_HDR.jpg",
            "slug": "img-20250917-110357002-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-110357002-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-110357002-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-110357002-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-110357002-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-110357002-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-110357002-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_134614812.jpg",
            "slug": "img-20250917-134614812-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-134614812-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-134614812-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-134614812-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-134614812-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-134614812-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-134614812-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_134646638_HDR.jpg",
            "slug": "img-20250917-134646638-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-134646638-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-134646638-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-134646638-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-134646638-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-134646638-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-134646638-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_134848450.jpg",
            "slug": "img-20250917-134848450-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-134848450-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-134848450-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-134848450-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-134848450-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-134848450-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-134848450-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_134949806.jpg",
            "slug": "img-20250917-134949806-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-134949806-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-134949806-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-134949806-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-134949806-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-134949806-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-134949806-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_135338348.jpg",
            "slug": "img-20250917-135338348-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-135338348-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-135338348-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-135338348-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-135338348-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-135338348-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-135338348-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_135434554.jpg",
            "slug": "img-20250917-135434554-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-135434554-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-135434554-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-135434554-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-135434554-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-135434554-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-135434554-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_135751575.jpg",
            "slug": "img-20250917-135751575-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-135751575-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-135751575-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-135751575-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-135751575-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-135751575-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-135751575-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_140322736.jpg",
            "slug": "img-20250917-140322736-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-140322736-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-140322736-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-140322736-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-140322736-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-140322736-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-140322736-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_140422766_HDR.jpg",
            "slug": "img-20250917-140422766-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-140422766-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-140422766-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-140422766-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-140422766-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-140422766-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-140422766-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_141039433.jpg",
            "slug": "img-20250917-141039433-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-141039433-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-141039433-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-141039433-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-141039433-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-141039433-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-141039433-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_141730964_HDR.jpg",
            "slug": "img-20250917-141730964-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-141730964-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-141730964-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-141730964-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-141730964-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-141730964-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-141730964-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_141807074.jpg",
            "slug": "img-20250917-141807074-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-141807074-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-141807074-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-141807074-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-141807074-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-141807074-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-141807074-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_141850106.jpg",
            "slug": "img-20250917-141850106-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-141850106-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-141850106-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-141850106-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-141850106-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-141850106-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-141850106-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_142115184_HDR.jpg",
            "slug": "img-20250917-142115184-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142115184-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-142115184-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142115184-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142115184-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-142115184-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142115184-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142211702_HDR.jpg",
            "slug": "img-20250917-142211702-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142211702-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142211702-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142211702-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142211702-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142211702-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142211702-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_142250172_HDR.jpg",
            "slug": "img-20250917-142250172-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142250172-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-142250172-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142250172-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142250172-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-142250172-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142250172-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142311351_HDR.jpg",
            "slug": "img-20250917-142311351-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142311351-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142311351-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142311351-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142311351-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142311351-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142311351-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142424597.jpg",
            "slug": "img-20250917-142424597-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142424597-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142424597-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142424597-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142424597-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142424597-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142424597-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142442851.jpg",
            "slug": "img-20250917-142442851-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142442851-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142442851-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142442851-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142442851-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142442851-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142442851-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_142457009_HDR.jpg",
            "slug": "img-20250917-142457009-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142457009-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-142457009-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-142457009-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142457009-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-142457009-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-142457009-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142603191.jpg",
            "slug": "img-20250917-142603191-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142603191-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142603191-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142603191-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142603191-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142603191-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142603191-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142619567.jpg",
            "slug": "img-20250917-142619567-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142619567-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142619567-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142619567-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142619567-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142619567-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142619567-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_142750969.jpg",
            "slug": "img-20250917-142750969-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142750969-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-142750969-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-142750969-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142750969-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-142750969-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-142750969-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_143307058.jpg",
            "slug": "img-20250917-143307058-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-143307058-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-143307058-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-143307058-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-143307058-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-143307058-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-143307058-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_144016193.jpg",
            "slug": "img-20250917-144016193-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-144016193-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-144016193-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-144016193-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-144016193-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-144016193-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-144016193-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_152701190_HDR.jpg",
            "slug": "img-20250917-152701190-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-152701190-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-152701190-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-152701190-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-152701190-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-152701190-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-152701190-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_152759511.jpg",
            "slug": "img-20250917-152759511-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-152759511-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-152759511-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-152759511-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-152759511-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-152759511-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-152759511-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_152911372.jpg",
            "slug": "img-20250917-152911372-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-152911372-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-152911372-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-152911372-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-152911372-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-152911372-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-152911372-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_153157643.jpg",
            "slug": "img-20250917-153157643-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-153157643-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-153157643-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-153157643-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-153157643-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-153157643-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-153157643-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_153236817.jpg",
            "slug": "img-20250917-153236817-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-153236817-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-153236817-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-153236817-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-153236817-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-153236817-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-153236817-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_154322460.jpg",
            "slug": "img-20250917-154322460-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-154322460-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-154322460-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-154322460-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-154322460-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-154322460-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-154322460-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_154838200.jpg",
            "slug": "img-20250917-154838200-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-154838200-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-154838200-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-154838200-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-154838200-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-154838200-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-154838200-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_155043265.jpg",
            "slug": "img-20250917-155043265-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-155043265-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-155043265-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-155043265-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-155043265-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-155043265-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-155043265-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_160053371.jpg",
            "slug": "img-20250917-160053371-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160053371-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-160053371-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160053371-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160053371-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-160053371-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160053371-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_160106939.jpg",
            "slug": "img-20250917-160106939-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160106939-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-160106939-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160106939-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160106939-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-160106939-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160106939-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_160138122.jpg",
            "slug": "img-20250917-160138122-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160138122-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-160138122-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160138122-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160138122-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-160138122-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160138122-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_160234751.jpg",
            "slug": "img-20250917-160234751-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160234751-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-160234751-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-160234751-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160234751-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-160234751-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-160234751-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_161044317.jpg",
            "slug": "img-20250917-161044317-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161044317-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-161044317-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161044317-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161044317-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-161044317-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161044317-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161117382.jpg",
            "slug": "img-20250917-161117382-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161117382-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161117382-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161117382-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161117382-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161117382-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161117382-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_161226514.jpg",
            "slug": "img-20250917-161226514-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161226514-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-161226514-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161226514-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161226514-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-161226514-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161226514-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161311913.jpg",
            "slug": "img-20250917-161311913-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161311913-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161311913-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161311913-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161311913-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161311913-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161311913-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161351079.jpg",
            "slug": "img-20250917-161351079-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161351079-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161351079-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161351079-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161351079-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161351079-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161351079-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161412572.jpg",
            "slug": "img-20250917-161412572-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161412572-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161412572-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161412572-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161412572-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161412572-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161412572-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161508423.jpg",
            "slug": "img-20250917-161508423-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161508423-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161508423-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161508423-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161508423-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161508423-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161508423-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161608677.jpg",
            "slug": "img-20250917-161608677-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161608677-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161608677-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161608677-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161608677-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161608677-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161608677-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_161653128.jpg",
            "slug": "img-20250917-161653128-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161653128-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-161653128-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161653128-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161653128-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-161653128-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161653128-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161706517.jpg",
            "slug": "img-20250917-161706517-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161706517-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161706517-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161706517-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161706517-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161706517-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161706517-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_161738170.jpg",
            "slug": "img-20250917-161738170-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161738170-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-161738170-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-161738170-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161738170-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-161738170-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-161738170-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_161945878.jpg",
            "slug": "img-20250917-161945878-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161945878-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-161945878-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-161945878-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161945878-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-161945878-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-161945878-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_162305954.jpg",
            "slug": "img-20250917-162305954-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-162305954-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-162305954-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-162305954-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-162305954-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-162305954-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-162305954-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_163018308.jpg",
            "slug": "img-20250917-163018308-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-163018308-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-163018308-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-163018308-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-163018308-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-163018308-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-163018308-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_163338753.jpg",
            "slug": "img-20250917-163338753-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-163338753-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-163338753-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-163338753-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-163338753-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-163338753-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-163338753-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_164818637.jpg",
            "slug": "img-20250917-164818637-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-164818637-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-164818637-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-164818637-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-164818637-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-164818637-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-164818637-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250917_165329593.jpg",
            "slug": "img-20250917-165329593-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-165329593-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x768_img-20250917-165329593-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x1200_img-20250917-165329593-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-165329593-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x600_img-20250917-165329593-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x375_img-20250917-165329593-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250917_165526388.jpg",
            "slug": "img-20250917-165526388-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-165526388-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1024x1365_img-20250917-165526388-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/1600x2133_img-20250917-165526388-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-165526388-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/800x1066_img-20250917-165526388-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-165526388-jpg.jpg",
            "width": 3072
         }
      ],
      "slug": "travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-puerto-de-mogan-dunas-de-maspalomas/500x666_img-20250917-110357002-hdr-jpg.jpg"
   },
   "travel-gran-canaria-sopa-de-azul": {
      "name": "travel-gran-canaria > sopa-de-azul",
      "photos": [
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250911_143531179_HDR.jpg",
            "slug": "img-20250911-143531179-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250911-143531179-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1024x768_img-20250911-143531179-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250911-143531179-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250911-143531179-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/800x600_img-20250911-143531179-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250911-143531179-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250911_143642742.jpg",
            "slug": "img-20250911-143642742-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250911-143642742-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1024x768_img-20250911-143642742-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250911-143642742-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250911-143642742-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/800x600_img-20250911-143642742-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250911-143642742-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250915_143823577.jpg",
            "slug": "img-20250915-143823577-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-143823577-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1024x768_img-20250915-143823577-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-143823577-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-143823577-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/800x600_img-20250915-143823577-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-143823577-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250915_171002176_HDR.jpg",
            "slug": "img-20250915-171002176-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-171002176-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1024x768_img-20250915-171002176-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-171002176-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-171002176-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/800x600_img-20250915-171002176-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-171002176-hdr-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250915_171048280_HDR.jpg",
            "slug": "img-20250915-171048280-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-171048280-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1024x768_img-20250915-171048280-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/1600x1200_img-20250915-171048280-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-171048280-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/800x600_img-20250915-171048280-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250915-171048280-hdr-jpg.jpg",
            "width": 4096
         }
      ],
      "slug": "travel-gran-canaria-sopa-de-azul",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-sopa-de-azul/500x375_img-20250911-143531179-hdr-jpg.jpg"
   },
   "travel-gran-canaria-teror": {
      "name": "travel-gran-canaria > teror",
      "photos": [
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250908_121524280_HDR.jpg",
            "slug": "img-20250908-121524280-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-121524280-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1024x1365_img-20250908-121524280-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-121524280-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-121524280-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/800x1066_img-20250908-121524280-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-121524280-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 3072,
            "name": "IMG_20250908_121532465.jpg",
            "slug": "img-20250908-121532465-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x1200_img-20250908-121532465-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1024x768_img-20250908-121532465-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x1200_img-20250908-121532465-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x375_img-20250908-121532465-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/800x600_img-20250908-121532465-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x375_img-20250908-121532465-jpg.jpg",
            "width": 4096
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250908_122336431_HDR.jpg",
            "slug": "img-20250908-122336431-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-122336431-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1024x1365_img-20250908-122336431-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-122336431-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-122336431-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/800x1066_img-20250908-122336431-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-122336431-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250908_132142502_HDR.jpg",
            "slug": "img-20250908-132142502-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-132142502-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1024x1365_img-20250908-132142502-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-132142502-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-132142502-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/800x1066_img-20250908-132142502-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-132142502-hdr-jpg.jpg",
            "width": 3072
         },
         {
            "faces": [],
            "height": 4096,
            "name": "IMG_20250908_151256776_HDR.jpg",
            "slug": "img-20250908-151256776-hdr-jpg",
            "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-151256776-hdr-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1024x1365_img-20250908-151256776-hdr-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/1600x2133_img-20250908-151256776-hdr-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-151256776-hdr-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/800x1066_img-20250908-151256776-hdr-jpg.jpg"
               ]
            },
            "thumb": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-151256776-hdr-jpg.jpg",
            "width": 3072
         }
      ],
      "slug": "travel-gran-canaria-teror",
      "src": "/my-gallery/static/_gallery/albums/travel-gran-canaria-teror/500x666_img-20250908-121524280-hdr-jpg.jpg"
   }
};